import Vue from "vue";
import VueI18n from 'vue-i18n';

import en from '@/i18n/en.js';
import tw from '@/i18n/tw.js';
import { get_init_locale } from '@/i18n/init.js'

import { UNITS_PUB } from '@/config/config';

let client_name = "DEMO"
const current_host = window.location.href.match('http(s?)://.*?/(.*)/');
if (current_host) {
    client_name = current_host[2]
}

Vue.use(VueI18n)

export default new VueI18n({
    locale: UNITS_PUB.includes(client_name) ? get_init_locale() : 'tw',
    messages: { en, tw }
})